import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import { formatPhone } from '../../../helpers/phoneFormatter';

import SpinnerBlock from '../../common/SpinnerBlock';
import EditOrLock from './common/EditOrLock';

import { showModal } from '../../../actions/modal';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const Wrapper = styled('div')`
  position: relative;
  padding-left: 0;
  padding-right: 0;
  box-shadow: none;
  border: 1px solid #ebebeb;
  > div {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-bottom: 10px;
    &:last-child {
      padding-bottom: 0;
    }
  }

  .buyer-name {
    text-overflow: ellipsis;
    overflow-x: hidden;
  }

  .block-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 22px;
    padding-top: 3px;
    h4 {
      font-size: 16px;
    }
    .left {
      .header-title {
        margin-bottom: 6px;
      }
    }
  }

  .block-subtitle {
    padding-top: 9px;
  }
`;

const ClientBlock = (props) => {
  const { isNew, currentOrder, loadingClient, handleEditClient } = props;

  const { t } = useAutoTranslation();

  const dispatch = useDispatch();
  const receiver = currentOrder.delivery && currentOrder.delivery.receiver;
  const clientName =
    receiver && `${receiver.name || ''} ${receiver.patronymic || ''} ${receiver.surname || ''}`;
  const hasClientInfo =
    receiver?.name ||
    receiver?.patronymic ||
    receiver?.surname ||
    receiver?.phone ||
    receiver?.alternativePhone ||
    receiver?.email;

  const handleOpenModal = () => {
    dispatch(
      showModal('EditOrderClient', {
        isNew,
        currentClient: !isNew ? currentOrder.delivery.receiver : {},
        currentLegalEntity: !isNew ? currentOrder.legalEntity || {} : {},
        currentDeliveryType: !isNew ? currentOrder?.delivery?.code : null,
        submitCallback: async (clientData, legalEntityData) => {
          await handleEditClient(clientData, legalEntityData);
        },
      }),
    );
  };

  return (
    <Wrapper className={`card-box ${!receiver ? 'add-info' : ''}`}>
      <SpinnerBlock show={loadingClient} />
      <div className="card-title block-title">
        <div className="left">
          <h4 className="header-title">{t('Покупатель')}</h4>
          {currentOrder.legalEntity?.type ? (
            <div>
              {currentOrder.legalEntity.type === 'PERSON'
                ? t('Физическое лицо')
                : t('Юридическое лицо')}
            </div>
          ) : null}
        </div>
        <EditOrLock
          permissions={currentOrder.permissionList}
          permissionKey="RECEIVER_EDITABLE"
          action={handleOpenModal}
        />
      </div>

      {receiver ? (
        <Fragment>
          <div className="border-top" style={{ display: 'flex', alignItems: 'center' }}>
            <div className="block-subtitle">{t('Контакты')}</div>
          </div>
          <div style={{ lineHeight: '2' }} className="card-content">
            {!hasClientInfo ? <div>{t('Нет данных')}</div> : null}

            <div className="buyer-name">{clientName}</div>
            {receiver.phone ? <div>{formatPhone(receiver.phone)}</div> : null}
            {receiver.alternativePhone ? <div>{formatPhone(receiver.alternativePhone)}</div> : null}
            {receiver.email ? <div>{receiver.email}</div> : null}
          </div>
        </Fragment>
      ) : (
        <div className="blocked-block">
          <div className="change-link" onClick={handleOpenModal}>
            {t('Добавить информацию')}
          </div>
        </div>
      )}
    </Wrapper>
  );
};

export default ClientBlock;
